import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class EncryptionUserEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationDTTM = new Date(0);
        this.email = null;
        this.genealogyCount = null;
        this.genealogyLevel = null;
        this.groupUserId = 0;
        this.hasAccess = false;
        this.isAuthor = false;
        this.isRead = false;
        this.userId = null;
    }
    pk() {
        return this.groupUserId.toString();
    }
}
EncryptionUserEntity.schema = {
    creationDTTM: ISODate
};
EncryptionUserEntity.key = 'EncryptionUser';
export { EncryptionUserEntity };
